module.exports = __webpack_public_path__ + "img/icon3.ff07a64e.svg";